import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState, IToastState } from './types';

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    setToast: (state, action: PayloadAction<Omit<IToastState, 'open'>>) => {
      return {
        ...state,
        ...action.payload,
        open: true,
      };
    },
    setDisableToast: (state) => {
      return {
        ...state,
        open: false,
      };
    },
  },
});

export const { setToast, setDisableToast } = toastSlice.actions;

export default toastSlice.reducer;
